function ScansSkeleton() {
    const skeletonItems = Array.from({ length: 3 }, (_, index) => index);

    return (
        <div className='flex pb-10'>
            <div className="flex flex-col items-center gap-16">
                {skeletonItems.map((_, index) => (
                    <div key={index} className="relative animate-pulse">
                        <div className="w-6 h-6 relative z-5 rounded-full border-2 border-gray-200">
                            <div className="w-3 h-3 absolute transform top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gray-200"></div>
                        </div>

                        <div className="absolute top-[-1px] left-9 flex flex-col gap-2">
                            <div className="h-4 bg-gray-200 rounded w-32"></div>
                            <div className="h-3 bg-gray-200 rounded w-24"></div>
                            <div className="h-3 bg-gray-200 rounded w-20"></div>
                        </div>

                        {index < skeletonItems.length - 1 && (
                            <div className="absolute left-1/2 -translate-x-1/2 w-1 h-16 bg-gray-200"></div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ScansSkeleton;
